#import "../../../../../graphql/fragments/peep-legacy-id-fragment.graphql"

query GetAccountLegacyId($accountId: ID!) {
    account(id: $accountId) {
        ...PeepLegacyIdFragment
    }
}
